import { lazyPage } from './lazyPage';
import type { AppRoute } from './types';

const ParentDashboard = lazyPage(() => import('@/pages/portal/ParentPortal'));
const MyChildren = lazyPage(() => import('@/pages/parent/MyChildren'));
const ChildProfile = lazyPage(() => import('@/pages/parent/ChildProfile'));
const MyProfile = lazyPage(() => import('@/pages/me/MyProfilePage'));
const ParentTimetable = lazyPage(() => import('@/pages/parent/Timetable'));
const ParentAttendance = lazyPage(() => import('@/pages/parent/Attendance'));
const ParentHomework = lazyPage(() => import('@/pages/parent/Homework'));
const ParentAssignments = lazyPage(() => import('@/pages/parent/Assignments'));
const ParentExamsResults = lazyPage(() => import('@/pages/parent/ExamsResults'));
const ParentHallTicket = lazyPage(() => import('@/pages/parent/HallTicket'));
const ParentPerformance = lazyPage(() => import('@/pages/parent/Performance'));
const ParentFeesPayments = lazyPage(() => import('@/pages/parent/FeesPayments'));
const ParentTransportDetails = lazyPage(() => import('@/pages/parent/TransportDetails'));
const ParentMedicalRecords = lazyPage(() => import('@/pages/parent/MedicalRecords'));
const ParentAnnouncements = lazyPage(() => import('@/pages/parent/Announcements'));
const ParentTeacherCommunication = lazyPage(() => import('@/pages/parent/TeacherCommunication'));
const ParentLeaveRequests = lazyPage(() => import('@/pages/parent/LeaveRequests'));

export const parentRoutes: AppRoute[] = [
  {
    path: 'parent',
    title: 'Parent Portal',
    children: [
      { path: '', title: 'Parent Portal', redirectTo: '/parent/dashboard' },
      { path: 'dashboard', title: 'My Dashboard', component: ParentDashboard },
      { path: 'children', title: 'My Children', component: MyChildren },
      { path: 'profile', title: 'Child Profile', component: ChildProfile },
      { path: 'my-profile', title: 'My Profile', component: MyProfile },
      { path: 'timetable', title: 'Timetable', component: ParentTimetable },
      { path: 'attendance', title: 'Attendance', component: ParentAttendance },
      { path: 'homework', title: 'Homework', component: ParentHomework },
      { path: 'assignments', title: 'Assignments', component: ParentAssignments },
      { path: 'exams', title: 'Exams & Results', component: ParentExamsResults },
      { path: 'hall-ticket', title: 'Hall Ticket', component: ParentHallTicket },
      { path: 'performance', title: 'Performance', component: ParentPerformance },
      { path: 'fees', title: 'Fees & Payments', component: ParentFeesPayments },
      { path: 'transport', title: 'Transport Details', component: ParentTransportDetails },
      { path: 'medical', title: 'Medical Records', component: ParentMedicalRecords },
      { path: 'announcements', title: 'Announcements', component: ParentAnnouncements },
      { path: 'teacher-communication', title: 'Teacher Communication', component: ParentTeacherCommunication },
      { path: 'leave', title: 'Leave Requests', component: ParentLeaveRequests },
    ],
  },
];
